module.exports = __webpack_public_path__ + "static/assets/2f504484a2315b6beea4c6e0e2a24e66.svg";